const API_BASE =
  (typeof window !== "undefined" && window.__FOLIOS_API_URL__) ||
  (typeof process !== "undefined" &&
    process.env &&
    process.env.REACT_APP_FOLIOS_API_URL) ||
  "https://6mxyn9sgze.execute-api.us-east-1.amazonaws.com";

const USE_MOCK =
  typeof process !== "undefined" &&
  process.env &&
  String(process.env.REACT_APP_FOLIOS_USE_MOCK || "").toLowerCase() === "true";

async function fetchJson(url) {
  const res = await fetch(url, {
    cache: "no-store"
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || "Error consultando Control de Folios");
  }

  return res.json();
}

export async function getFoliosCommandCenter(options = {}) {
  if (USE_MOCK) {
    return {
      ok: true,
      summary: {},
      municipios: [],
      cancelacionesDetalle: [],
      cancelacionesPorCausa: [],
      cancelacionesPorUsuario: [],
      sinReporte: [],
      auditoria: []
    };
  }

  const params = new URLSearchParams();

  if (options.force === true) params.set("force", "true");
  if (options.fechaInicio) params.set("fechaInicio", options.fechaInicio);
  if (options.fechaFin) params.set("fechaFin", options.fechaFin);

  const query = params.toString();

  const url =
    String(API_BASE).replace(/\/$/, "") +
    "/folios/command-center" +
    (query ? "?" + query : "");

  console.log("[FOLIOS_API]", url);

  return fetchJson(url);
}

export async function searchFolioRemote(query, options = {}) {
  const clean = String(query || "").trim();

  if (!clean) {
    return {
      ok: true,
      folio: "",
      query: "",
      detectedType: "",
      total: 0,
      bestMatch: null,
      matches: []
    };
  }

  const params = new URLSearchParams();
  params.set("q", clean);

  if (options.fechaInicio) params.set("fechaInicio", options.fechaInicio);
  if (options.fechaFin) params.set("fechaFin", options.fechaFin);
  if (options.municipio && options.municipio !== "TODOS") {
    params.set("municipio", options.municipio);
  }

  const url =
    String(API_BASE).replace(/\/$/, "") +
    "/folios/search?" +
    params.toString();

  console.log("[FOLIOS_SEARCH]", url);

  const result = await fetchJson(url);

  return {
    ok: result.ok === true,
    folio: clean,
    query: result.query || clean,
    detectedType: result.detectedType || "",
    total: result.total || 0,
    bestMatch: result.bestMatch || null,
    matches: Array.isArray(result.results) ? result.results : []
  };
}
